import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    raceSessionNotes: {
        data: [],
    },
};

export const raceSessionNotesReducer = (state = initialState, action) => {
  switch (action.type) {
        case actionTypes.CREATE_UPDATE_RACE_SESSION_NOTES:
          return {
            ...state,
            raceSessionNotes: action.payload,
          };
          case actionTypes.EMPTY_RACE_SESSION_NOTES:
            return {
              ...state,
              raceSessionNotes: action.payload,
            };
    default:
      return state;
      
  }

};
